import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class UnauthorizedResponseInterceptor implements HttpInterceptor {
    constructor(private readonly router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(tap(
            (_) => {},
            (error) => {
                if (error.status === 401) {
                    this.router.navigate(['/login']).then();
                }
            }
        ));
    }
}
